import type { SearchResult } from '@/scopes/search/search/infrastructure/api/types'
import { IconGlyph, Typography } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { styled } from 'styled-components'
import * as List from '../ListItem'
import { CampaignDetails } from './CampaignDetails'

const Item = styled(List.Item)`
  align-items: center;
`

const ItemContent = styled.span`
  display: inline-flex;
`

export function CampaignUsp({ campaign }: { campaign: SearchResult['campaign'] }) {
  if (!campaign)
    return null
  const { title, highlightedWord } = campaign
  // TODO: Now icon is hardcoded has to been map to new UDS icons
  // const bulletIcon = icon ? (icon as IconGlyph) : 'IconTag'
  const bulletIcon = 'Tag' as IconGlyph

  let campaignTitle = <Typography $variant="body-s-regular-tight">{title}</Typography>

  if (highlightedWord && highlightedWord !== '' && title.includes(highlightedWord)) {
    const splitTitle = title.split(highlightedWord)
    campaignTitle = (
      <Typography $variant="body-s-regular-tight">
        {splitTitle[0]}
        <Typography $variant="body-s-bold-tight">{highlightedWord}</Typography>
        {splitTitle[1]}
      </Typography>
    )
  }

  // Todo replace with new UDS icon component
  return (
    <Item $icon={bulletIcon} $size={16} data-qa="product-campaign-usp">
      <ItemContent>
        {campaignTitle}
        <CampaignDetails {...campaign} />
      </ItemContent>
    </Item>
  )
}
